// lib/coupons/shortfall.ts
//
// «Te faltan $X» de un cupón rechazado por `min_subtotal`.
//
// A1b (TABC): el servidor mide el mínimo sobre la base del cupón, o sea el
// subtotal SIN las líneas de alcohol. Cuando excluyó algo, su rechazo trae esa
// base en `measuredSubtotal`; restarle el subtotal COMPLETO al mínimo
// subestimaría lo que falta justo por el monto del alcohol. Sin alcohol el
// servidor no manda el campo y la cuenta es `mínimo − subtotal`, la de siempre.

/**
 * Subtotal contra el que el servidor midió el mínimo: su `measuredSubtotal` si
 * lo mandó (finito, nunca por encima del subtotal enviado), si no el `subtotal`.
 */
export function couponMeasuredSubtotal(subtotal: number, measuredSubtotal?: number | null): number {
  if (typeof measuredSubtotal !== "number" || !Number.isFinite(measuredSubtotal)) return subtotal
  return Math.min(subtotal, Math.max(0, measuredSubtotal))
}

/**
 * Lo que falta para llegar al mínimo, redondeado a centavo. Puede ser ≤ 0 si ya
 * lo alcanza: el llamador decide si pinta el mensaje con monto o el genérico.
 */
export function couponShortfall(minSubtotal: number, subtotal: number, measuredSubtotal?: number | null): number {
  return Math.round((minSubtotal - couponMeasuredSubtotal(subtotal, measuredSubtotal)) * 100) / 100
}

/**
 * Qué decir cuando el servidor rechaza por `min_subtotal` (POS): con el monto
 * que falta si el mínimo está por encima de lo medido, o el genérico si no
 * (sin `minSubtotal`, o el cliente ya lo alcanza y el rechazo vino de otro lado).
 */
export function couponMinSubtotalCopy(
  minSubtotal: number | undefined | null,
  subtotal: number,
  measuredSubtotal?: number | null,
): { kind: "missing"; min: number; missing: number } | { kind: "generic" } {
  if (minSubtotal == null || !(minSubtotal > couponMeasuredSubtotal(subtotal, measuredSubtotal))) {
    return { kind: "generic" }
  }
  return { kind: "missing", min: minSubtotal, missing: couponShortfall(minSubtotal, subtotal, measuredSubtotal) }
}
